// Utils
import { getComparisonAltDisclaimers } from './alts';
import { getComparisonFundDisclaimers } from './funds';
import { getComparisonStockDisclaimers } from './stocks';
import { getComparisonPortfolioDisclaimers, getPortfolioDisclaimers, getPortfolioHoldingDisclaimers } from './portfolios';
import { getComparisonBenchmarkDisclaimers } from './benchmarks';
import { getComparisonItemBenchmarkDisclaimers } from './comparison';

import helpers from './helpers';

export default {
  ...helpers,
  getComparisonAltDisclaimers,
  getComparisonFundDisclaimers,
  getComparisonPortfolioDisclaimers,
  getComparisonStockDisclaimers,
  getPortfolioHoldingDisclaimers,
  getPortfolioDisclaimers,
  getComparisonBenchmarkDisclaimers,
  getComparisonItemBenchmarkDisclaimers,
};
